import styled from "styled-components";

export const UserSummary = styled.div`
  margin-bottom: 0;

  h3 {
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StatCard = styled.div`
  text-align: center;
  padding: 16px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  .number {
    font-size: 28px;
    font-weight: 700;
    color: var(--brand);
    line-height: 1;
    margin-bottom: 4px;
  }

  .label {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

export const UserTableHeader = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr auto;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 8px;

  .avatar-col {
    width: 48px;
  }

  .name-col {
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .type-col {
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: right;
  }
`;

